export default __webpack_public_path__ + "static/media/v-full.cf41547d.svg";